import { asNodeIDArray } from "@hex-insights/app-modules";
import { TypeFilterObject, valuesTypeFilter } from "@hex-insights/core";
import { User } from "../../../Utilities";

export type StandardFilterFormValues = {
	status: "Upcoming" | "Live" | "Expired" | null;
	authorIDIn: User["id"][];
	sharedUserIDsIn: User["id"][];
};

export const initialStandardFilters: StandardFilterFormValues = {
	status: null,
	authorIDIn: [],
	sharedUserIDsIn: [],
};

export const standardFiltersTypeFilterObject: TypeFilterObject<StandardFilterFormValues> = {
	status: valuesTypeFilter(["Upcoming", "Live", "Expired", null], null),
	authorIDIn: asNodeIDArray,
	sharedUserIDsIn: asNodeIDArray,
};
